import UnrelatedTag from "@/components/StatusTags/UnrelatedTag";
import Table from "@/components/Table/Table";
import useTableStateParams from "@/components/Table/hooks/useTableState";
import { useGetPackagingMaterialRelatedPackaging } from "../usePackagingMaterials";
import { packagingLabel } from "@/utilities/packaging";
import ProductPackagingTag from "@/components/StatusTags/ProductPackagingTag";
import LogisticsPackagingTag from "@/components/StatusTags/LogisticsPackagingTag";

export default function PackagingMaterialRelatedPackagingTable({
  materialId,
}: {
  materialId: number;
}) {
  const { pagination, onSearchFilterSortPaginate } = useTableStateParams({
    defaultPagination: { page: 1, pageSize: 10 },
  });
  const { data, isLoading, isFetching } = useGetPackagingMaterialRelatedPackaging({
    materialId,
    pagination,
  });
  const loading = isLoading || isFetching;

  return (
    <Table
      loading={loading}
      type="grey"
      emptyState={{ hide: true }}
      hideRaster={true}
      pagination={pagination}
      totalRows={data?.total_count}
      data={data?.related_packaging}
      onSearchFilterSortPaginate={onSearchFilterSortPaginate}
      rowLink={(record) =>
        record.relation === "primary" ? `/packaging/${record.id}` : `/facilities/${record.id}`
      }
      columns={[
        {
          label: "Name",
          key: "id",
          renderer: (record) =>
            record.relation === "primary"
              ? packagingLabel(record.external_id, record.name)
              : record.name,
        },
        {
          label: "Relation",
          key: "proxy_weight",
          renderer: (record) => (
            <>
              {record.relation === "primary" ? <ProductPackagingTag /> : <LogisticsPackagingTag />}
              {record.unrelated && <UnrelatedTag />}
            </>
          ),
        },
      ]}
      rowKey={"id"}
    />
  );
}
